<template>
    <div class="card social-searcher" :id="'social-searcher-'+social_searcher.id">
        <div class="card-header sticky-top" style="top: 7.75rem;">
            <h2 class="card-title py-1 my-0">
            {{social_searcher.keyword}}
            </h2>
            <div class="card-tools">
                <div v-if="remaining_searches!==null">
                    <span v-if="!monitoring">
                        {{translate('messages.remaining_searches')}} : <span class="h4"><Roller class="d-inline-block px-1 badge" style="margin-bottom: -0.5rem;" :class="'badge-'+$options.filters.heatmap_class(remaining_searches_ratio)" :transition="1" :text="remaining_searches+''"></Roller></span>
                    </span>
                    <span v-else-if="monitoring" class="blink">
                        {{translate('messages.retrieving_results')}} 
                    </span>
                    <button class="btn btn-tool no-shadow" @click="renewSearchControl()" v-tooltip:bottom="translate('messages.execute_search')" data-toggle="tooltip">
                        <radar :monitoring="monitoring"/>
                    </button>
                </div>
                <i v-else class="fas fa-spinner fa-pulse"></i>
            </div>
        </div>
        <div v-if="active_networks.length" class="card-toolbar card-header social-searcher-filters p-1 text-right">
            
                <button type="button" class="btn btn-default btn-sm" data-toggle="collapse" :href="'#social-searcher-filters-'+social_searcher.id" aria-expanded="false" aria-controls="filters">
                    <i class="fas fa-filter"></i> {{translate('messages.filters')}}
                </button>
                <button class="btn btn-default btn-sm" :class="$root.app_config.dark_mode ? 'white' : ''" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand fa-lg" style="vertical-align: middle;"></i></button>
                <div class="collapse" :id="'social-searcher-filters-'+social_searcher.id">
                    <div class="card card-body shadow-none border-0 px-0 py-2 bg-transparent">
                        <div class="d-flex flex-column flex-xl-row align-items-xl-center">
                            <div class="py-2 px-3 text-left">
                                <h4 class="mb-1">{{translate('messages.social_networks')}}</h4>
                                <span role="button" @click="setNetworksFilter('all')" class="pb-1 px-1 mr-2 d-inline-block"><i class="fas fa-check-square"></i> {{translate('messages.all_a')}}</span>
                                <span role="button" @click="setNetworksFilter('none')" class="pb-1 px-1 mr-2 d-inline-block"><i class="far fa-square"></i> {{translate('messages.none_a')}}</span><br>
                                <div class="btn-group btn-group-toggle d-inline-block">
                                    <label v-for="(network) in active_networks" :key="'active-network-'+network" class="btn rounded-0" :class="($root.app_config.dark_mode ? 'btn-outline-dark' : 'btn-default')" style="min-width: 65px">
                                        <input :value="network" class="custom-control-input" type="checkbox" :id="'filter-checkbox-'+social_searcher.id+'-'+network" @click="setNetworksFilter(network)" :checked="selected_networks.includes(network)">
                                        <i v-if="selected_networks.includes(network)" class="fas fa-check-square notiblue"></i>
                                        <i v-else class="far fa-square"></i>
                                        <i :class="$options.filters.icon_class(network)+' '+($root.app_config.dark_mode ? 'white' : '')" class="fa-lg"></i>
                                    </label>
                                </div>
                            </div>
                            <div class="py-2 px-3 flex-grow-1 text-left">
                                <h4 class="mb-1">{{translate('messages.date')}}</h4>
                                <date-picker v-model="date_range" :lang="$gate.language()" :format="'YYYY-MM-DD'" :disabled-date="disabledDates" :open.sync="datepicker_open" range class="d-block">
                                    <template v-slot:footer="{ emit }">
                                        <div style="text-align: left">
                                            <button class="mx-btn mx-btn-text" @click="selectLastDays(emit, 6)">
                                                {{translate('messages.last_seven_days')}}
                                            </button>
                                            <button class="mx-btn mx-btn-text" @click="selectLastDays(emit, 30)">
                                                {{translate('messages.last_thirty_days')}}
                                            </button>
                                        </div>
                                    </template>
                                </date-picker>
                            </div>
                            <div class="pb-2 pt-1 px-3">
                                <button class="btn btn-warning btn-block mt-1 mr-2" :disabled="filtering" @click="resetFilters">{{translate('messages.reset')}}</button>
                                <button class="btn btn-notiblue btn-block mt-1 mr-2" :disabled="filtering" @click="applyFilter">{{filtering ? translate('messages.filtering') : translate('messages.do_filter')}}</button>
                            </div>
                        </div>
                        <div v-if="filtering" class="overlay" :class="$root.app_config.dark_mode ? 'dark' : ''">
                            <span class="h3"><i class="fas fa-spinner fa-pulse"></i> {{filter_applied ? translate('messages.filtering') : ''}}</span>
                        </div>
                    </div>
                </div>
         
        </div>
        <!-- /.card-header -->
        <div class="card-body pt-1">
            
            <div v-show="!loading" class="row align-items-center pb-4" style="min-height: 260px;">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                    <div class="small-box bg-secondary mb-3">
                        <div class="inner">
                            <h3>Total</h3>

                            <div class="h2"><Roller class="d-inline-block" style="margin-bottom: -0.85rem;" :transition="1" :text="total_posts+''"></Roller> <span style="font-size: 1rem; font-weight: normal;">{{translate('messages.mentions')}}</span></div>
                            
                        </div>
                        <div class="icon d-block">
                            <i class="far fa-comments"></i>
                        </div>
                    </div>
                    <div v-if="!loading && !empty_results && !processing_search" class="small-box bg-secondary mb-3">
                        <div class="inner">
                            <h3 style="font-size: 1.5rem">{{translate('messages.interactions')}}</h3>
                            <div v-for="(count, popularity) in popularity_counts" :key="'popularity-overview-'+popularity">
                                <span class="badge badge-pill badge-dark" style="vertical-align: middle;">
                                    <i class="fas fa-sm" :class="popularity | icon_class"></i>
                                </span> <span>{{count}} {{popularity}}</span>
                            </div>
                        </div>
                        <div class="icon d-block">
                            <i class="fas fa-share-alt"></i>
                        </div>
                    </div>
                    
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                    <div v-if="processing_search">
                        <div class="alert alert-success">
                            <h5 class="m-0"><i class="fas fa-check-circle"></i> {{translate('messages.first_search_message')}}</h5>
                        </div>
                    </div>
                    <div v-else-if="empty_results && !processing_search" class="alert alert-warning">
                        <h5><i class="icon fas fa-exclamation-triangle"></i> {{translate('messages.empty_results')}}</h5>
                        {{translate('messages.empty_results_message')}}.
                    </div>
                    <div class="row">
                        <div v-for="(sentiment_counts, network) in networks_counts" :key="'network-data-'+network" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                            <div class="small-box mb-3" :class="network+'-brand-bg'">
                                <div class="inner pb-4">
                                    <h4>{{network | capitalize}}</h4>
                                    <div class="h3"><Roller class="d-inline-block" style="margin-bottom: -0.85rem;" :transition="1" :text="sentiment_counts['total']+''"></Roller> <span style="font-size: 1rem; font-weight: normal;">{{translate('messages.mentions')}}</span></div>
                                </div>
                                <div class="icon d-block">
                                    <i :class="network | icon_class"></i>
                                </div>
                                <div class="small-box-footer p-0">
                                    <div class="progress" style="height: 1.25rem;">            
                                        <div v-if="sentiment_counts.positive" class="progress-bar py-1" :class="'bg-'+$options.filters.color_class('positive')" role="progressbar" :style="'width: '+sentiment_counts.percents.positive.toFixed(2)+'%'" v-tooltip:bottom="translate('messages.positive')+': '+sentiment_counts.positive+' ('+sentiment_counts.percents.positive.toFixed(0)+'%) '" data-toggle="tooltip">
                                            <span><i class="fas fa-thumbs-up"></i> {{sentiment_counts.positive}}</span>
                                        </div>
                                        <div v-if="sentiment_counts.negative" class="progress-bar py-1" :class="'bg-'+$options.filters.color_class('negative')" role="progressbar" :style="'width: '+sentiment_counts.percents.negative.toFixed(2)+'%'" v-tooltip:bottom="translate('messages.negative')+': '+sentiment_counts.negative+' ('+sentiment_counts.percents.negative.toFixed(0)+'%) '" data-toggle="tooltip">
                                            <span><i class="fas fa-thumbs-down"></i> {{sentiment_counts.negative}}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row align-items-center pb-4" v-if="!loading && !empty_results && !processing_search">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                    <h5 class="text-center m-0">{{translate('messages.sentiments')}}</h5>
                    <div style="max-width: 300px; margin: 0 auto;">
                        <polarArea :chartData="sentimentDataCollection.chart_data" :options="sentimentDataCollection.chart_options" class="pb-2" />
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title py-1 my-0">{{translate('messages.sentiments')}} {{translate('messages.by')}} {{translate('messages.date')}}</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-default btn-sm" @click="generatePDF('sentiments')" :disabled="generating_pdf">
                                    <i class="fas fa-download"></i> <span v-if="!generating_pdf">{{translate('messages.download')}}</span><span v-else>{{translate('messages.downloading')}}</span>
                                </button>
                                <button type="button" class="btn btn-default btn-sm" :class="sentimentOverviewDataCollection.group_by == 'month' ? 'active' : ''" @click="renderSentimentOverviewChart('month')">
                                    {{translate('messages.month')}}
                                </button>
                                <button type="button" class="btn btn-default btn-sm" :class="sentimentOverviewDataCollection.group_by == 'day' ? 'active' : ''" @click="renderSentimentOverviewChart('day')">
                                    {{translate('messages.day')}}
                                </button>
                            </div>
                        </div>
                        <div class="card-body p-0 m-0" style="overflow: hidden;">
                            <line-chart ref='sentiment_overview_chart' :chart-id="'sentiment-overview-chart-'+social_searcher.id" :chartData="sentimentOverviewDataCollection.chart_data" :options="sentimentOverviewDataCollection.chart_options" :styles="overviewChartsStyles" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row align-items-center pb-4" v-if="!loading && !empty_results && !processing_search">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                    <h5 class="text-center m-0">{{translate('messages.social_networks')}}</h5>
                    <div style="max-width: 300px; margin: 0 auto;">
                        <polarArea :chartData="networkDataCollection.chart_data" :options="networkDataCollection.chart_options" class="pb-2" />
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title py-1 my-0">{{translate('messages.social_networks')}} {{translate('messages.by')}} {{translate('messages.date')}}</h3>
                            <div class="card-tools">
                                 <button type="button" class="btn btn-default btn-sm" @click="generatePDF('social_networks')" :disabled="generating_pdf">
                                    <i class="fas fa-download"></i> <span v-if="!generating_pdf">{{translate('messages.download')}}</span><span v-else>{{translate('messages.downloading')}}</span>
                                </button>
                                <button type="button" class="btn btn-default btn-sm" :class="networkOverviewDataCollection.group_by == 'month' ? 'active' : ''" @click="renderNetworkOverviewChart('month')">
                                    {{translate('messages.month')}}
                                </button>
                                <button type="button" class="btn btn-default btn-sm" :class="networkOverviewDataCollection.group_by == 'day' ? 'active' : ''" @click="renderNetworkOverviewChart('day')">
                                    {{translate('messages.day')}}
                                </button>
                            </div>
                        </div>
                        <div class="card-body p-0 m-0" style="overflow: hidden;">
                            <line-chart ref="social_networks_overview_chart" :chart-id="'social-networks-overview-chart-'+social_searcher.id" :chartData="networkOverviewDataCollection.chart_data" :options="networkOverviewDataCollection.chart_options" :styles="overviewChartsStyles" />
                        </div>
                    </div>
                </div>
            </div>
            
                
            <div class="row pb-4" v-if="!loading && !empty_results && !processing_search">
                <div v-for="(posts_c, index) in sentiment_posts" :key="'post-c-'+index" class="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-6" v-show="!loading && !empty_results && !processing_search">
                    <div class="card social-searcher-sentiment" :class="'card-'+$options.filters.color_class(index)">
                        <div class="card-header">
                            <h3 class="card-title py-1 my-0">{{translate('messages.'+index)}}<span class="title-keyword">: {{social_searcher.keyword}}</span></h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body px-1">
                            <div v-if="!posts_c.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                            <div v-for="post in posts_c" :key="'post-'+post.vid" class="card card-outline single-post shadow-none" :class="'card-'+$options.filters.color_class(post.sentiment)">
                                <div class="card-header">
                                    <div class="card-tools float-left">
                                        <span class="badge p-2 align-middle" :class="post.network+'-brand-bg'"><i class="fa-2x" :class="post.network | icon_class"></i></span> <span class="align-middle text-capitalize">{{post.network}}</span>
                                    </div>
                                    <small class="text-capitalize float-right text-right">{{post.posted | localDate}}</small>
                                </div>
                                <!-- /.card-header -->
                                <div class="card-body">
                                    <div class="user-block float-none">
                                        <img v-if="post.user.image" class="img-circle" :src="post.user.image" :alt="post.user.name">
                                        <img v-else class="img-circle" src="images/profile.png">
                                        <span class="username"><a target="_BLANK" :href="post.user.url">{{post.user.name}}</a></span>
                                        <span v-if="post.user.description" class="description">{{post.user.description}}</span>
                                        <span v-else class="description">&nbsp;</span>
                                    </div>
                                    <p :inner-html.prop="post | formatSocialSearchPost" class="pt-2"></p>
                                    <div v-if="post.image" class="text-center">
                                        <img :src="post.image" class="img-fluid" :alt="post.network">
                                    </div>
                                </div>
                                <!-- /.card-body -->
                                <div class="card-footer">
                                    <div class="card-tools left">
                                        <a :href="post.url" class="btn pl-0 post-type" target="_BLANK">
                                            <i class="fas fa-lg" :class="post.type | icon_class"></i> {{translate('messages.'+post.type)}}
                                        </a>
                                        <span v-for="popularity in post.popularity" :key="'popularity-'+popularity.name" v-tooltip:bottom="popularity.name" class="badge badge-pill badge-dark mx-1" style="cursor: default" data-toggle="tooltip">
                                            <i v-if="$options.filters.icon_class(popularity.name)" class="fas fa-sm" :class="popularity.name | icon_class"></i>
                                            <span v-else>{{popularity.name}}: </span>
                                            {{popularity.count}}
                                        </span>
                                    </div>
                                    <div class="card-tools">
                                        <button v-if="webShareApiSupported" type="button" class="btn pr-0" v-tooltip:bottom="translate('messages.share')" data-toggle="tooltip" @click="share(post.url)">
                                            <i class="fas fa-share fa-lg"></i>
                                        </button>
                                        <button v-else type="button" class="btn pr-0" v-tooltip:bottom="translate('messages.copy_url_to_clipboard')" data-toggle="tooltip" @click="copyToClipboard(post.url)">
                                            <i class="far fa-copy fa-lg"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pb-4" v-if="!loading && !empty_results && !processing_search">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <tag-cloud :tags="tags"/>
                </div>
            </div>
            <div class="row" v-if="!loading && !empty_results && !processing_search">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                    <div class="card user-mentions">
                        <div class="card-header bg-black">
                            <h3 class="card-title py-1 my-0">{{translate('messages.user_mentions')}}<span class="title-keyword">: {{social_searcher.keyword}}</span></h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div v-if="Object.keys(user_mentions).length">
                                <table class="table table-striped m-0">
                                    <tbody v-for="(user_mention, network) in user_mentions" :key="'user-mention-'+network">
                                        <tr>
                                            <th class="p-1 text-center border-0 sticky-top" :class="network+'-brand-bg'" style="width: 1rem; z-index: 1018">
                                                <i :class="network | icon_class"></i>
                                            </th>
                                            <th class="p-1 text-center sticky-top bg-dark border-0" style="z-index: 1018;">#</th>
                                            <th class="p-1 sticky-top bg-dark border-0" style="z-index: 1018;">{{translate('messages.user')}}</th>
                                            <th class="p-1 sticky-top bg-dark border-0" style="z-index: 1018;">{{translate('messages.count')}}</th>
                                        </tr>
                                        <tr v-for="(data, user, index) in user_mention" :key="'user-mention-'+user">
                                            <td class="p1 border-0" :class="network+'-brand-bg'"></td>
                                            <td class="p-1 text-center">{{index+1}}.</td>
                                            <td class="user-mention p-1" :title="user">
                                                <a :href="data.url" target="_BLANK">{{user}}</a>
                                            </td>
                                            <td class="p-1">{{data.total}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                    <div class="card frequent-words">
                        <div class="card-header bg-black">
                            <h3 class="card-title py-1 my-0">{{translate('messages.frequent_words')}}<span class="title-keyword">: {{social_searcher.keyword}}</span></h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <table class="table" v-if="Object.keys(frequent_words).length">
                                <thead>
                                    <tr>
                                        <th class="text-center sticky-top bg-dark" style="z-index: 1018;">#</th>
                                        <th class="sticky-top bg-dark" style="z-index: 1018;">{{translate('messages.word')}}</th>
                                        <th class="sticky-top bg-dark" style="z-index: 1018;">{{translate('messages.count')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(value, word, index) in frequent_words" :key="'word-'+word" class="h4">
                                        <td class="text-center" >{{index+1}}.</td>
                                        <td class="frequent-word" :title="word.substring(1)">{{word.substring(1)}}</td>
                                        <td>{{value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-else class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="overlay dark">
            <i class="fas fa-sync fa-spin fa-2x"></i>
        </div>
    </div>
</template>
 
<script>
import PolarArea from '../charts/PolarAreaChart.js'
import LineChart from '../charts/LineChart.js'
import moment from 'moment-timezone';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.addVirtualFileSystem(pdfFonts);

export default {
    props: ['social_searcher', 'main_feed_id'],
    components: {
      PolarArea,
      LineChart
    },
    data () {
        return {
            posts: {},
            sentiment_posts:{},
            total_posts: 0,
            networks_counts: {},
            popularity_counts: {},
            loading : true,
            loading_data: true,
            sentimentDataCollection: {},
            networkDataCollection: {},
            frequent_words : {},
            monitoring : false,
            empty_results : false,
            processing_search : false,
            tags : {},
            user_mentions : {},
            sentimentOverviewDataCollection : {group_by: 'day'},
            networkOverviewDataCollection : {group_by: 'day'},
            overviewChartsStyles : {height: '300px', width: '100%'},
            filter_applied: false,
            filtering: false,
            active_networks: [],
            selected_networks: [],
            date_range : [null, null],
            start_date: null,
            end_date : moment(),
            datepicker_open: false,
            remaining_searches : null,
            remaining_searches_ratio : null,
            generating_pdf: false,
            timer: null
        }
    },
    methods: {
        loadData(){
            this.loading_data = true;
            axios.get("/api/socialSearcher/info").then((data) => {
                this.remaining_searches_ratio = data.data.data.user_features_usage.social_searches.remaining/data.data.data.user_features_usage.social_searches.value;
                this.remaining_searches = data.data.data.user_features_usage.social_searches.remaining;
                this.loading_data = this.loading;
            }).catch((error) => {
                this.loading_data = this.loading;
            });
        },
        renewSearchControl(){
            if(this.monitoring || this.loading || this.loading_data) return;
            if(this.remaining_searches == 10 || this.remaining_searches == 3){
                Swal.fire({
                    title: window.translate('messages.last_searches_message'),
                    text: window.translate('messages.you_have')+' '+this.remaining_searches+' '+window.translate('messages.remaining_searches_this_month'),
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonColor: '#3085d6',
                    cancelButtonText: window.translate('messages.cancel'),
                    confirmButtonText: window.translate('messages.execute_search')
                }).then((result) => {
                    if (result.value) this.renewSearch();
                })
            }else{
                this.renewSearch();
            }
        },
        renewSearch(){
            this.monitoring = true;
            this.timer = setInterval(function(){
                this.loadResults();
            }.bind(this), 10 * 1000);

            axios.get('/api/socialSearcher/renewSearch/'+this.social_searcher.id).then((data) => {
                Toast.fire({
                    icon: 'success',
                    title: this.social_searcher.keyword+'. '+window.translate('messages.posts_loaded')
                });
                this.monitoring = false;
                clearInterval(this.timer);
                this.loadResults();
            }).catch((error) => {
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.monitoring = false;
                clearInterval(this.timer);
                this.loadResults();
            });
        },
        loadResults(){
            var keywords = this.social_searcher.keyword.split(' ');
            var ignored_words = keywords.concat(Vue.prototype.$ignoredWords.words);
            axios.get("/api/socialSearcher/posts/"+this.social_searcher.id).then((data) => {
                if (data.status == 204){
                    this.loading = false;
                    this.processing_search = true;
                    this.$root.$emit('loadData');
                    return;
                }
                this.processing_search = false;
                let allposts = data.data.data.posts;
                allposts.sort((a,b) => (a.posted < b.posted) ? 1 : ((b.posted < a.posted) ? -1 : 0));
                let posts = [];
                let sentiment_posts = {
                    positive : [],
                    negative : [],
                };
                let networks_counts = {};
                let frequent_words = {};
                let tags = {};
                let user_mentions = {};
                let popularity_counts = {};
                this.active_networks = data.data.data.active_networks;
                if(!this.filter_applied) this.selected_networks = this.active_networks;
                if(!this.start_date && allposts.length) this.start_date = moment.utc(allposts[allposts.length-1].posted, 'YYYY-MM-DD HH:mm:ss +00000').startOf('day');
                allposts.forEach((post, index) => {
                    if(this.filter_applied && !this.selected_networks.includes(post.network)) return;
                    if(this.filter_applied && this.date_range[0] && this.date_range[1] && !moment.utc(post.posted, 'YYYY-MM-DD HH:mm:ss +00000').isBetween(this.date_range[0].setHours(0,0,0), this.date_range[1].setHours(23,59,59))) return;
                    
                    posts.push(post);
                    // Build sentiments
                    post.vid = index;
                    switch(post.sentiment){
                        case 'positive':
                            sentiment_posts.positive.push(post);
                            break;
                        case 'negative':
                            sentiment_posts.negative.push(post);
                            break;
                    }

                    // Build networks
                    networks_counts[post.network] = networks_counts[post.network] || {total: 0, percents: {}}
                    networks_counts[post.network][post.sentiment] = networks_counts[post.network][post.sentiment] || 0;
                    networks_counts[post.network][post.sentiment]++;
                    networks_counts[post.network]['total']++;

                    // Build popularity
                    if(post.popularity){
                        post.popularity.forEach((popularity) => {
                            popularity_counts[popularity.name] = popularity_counts[popularity.name] || 0;
                            popularity_counts[popularity.name] = popularity_counts[popularity.name] + popularity.count;
                        });
                    }
                           

                    // Build frequent words
                    let words = post.text.split(' ');
                    for(var i = 0; i < words.length; i++){
                        let word = words[i].toLowerCase().replace(',','').replace('.','').replace('(','').replace(')','').replace(':','').replace('"','').replace("'","").replace(';','');
                        if (word.length > 3 && !ignored_words.some(el => word.includes(el)) ){
                            frequent_words["_" + word] = (frequent_words["_" + word] || 0) + 1;
                        }
                    }

                    //Build hashtags
                    if(post.tags){
                        post.tags.forEach((tag) => {
                            let tag_name = '#'+tag['text'].toLowerCase();
                            tags[tag_name] = tags[tag_name] ?? {}; 
                            tags[tag_name]['total'] = tags[tag_name]['total'] ? tags[tag_name]['total'] + 1 : 1;
                            tags[tag_name]['networks'] = tags[tag_name]['networks'] ?? {}; 
                            tags[tag_name]['networks'][post.network] = tags[tag_name]['networks'][post.network] ?? {};
                            tags[tag_name]['networks'][post.network]['url'] = tag['url'];
                            tags[tag_name]['networks'][post.network]['total'] = tags[tag_name]['networks'][post.network]['total'] ? tags[tag_name]['networks'][post.network]['total'] + 1 : 1;
                        });
                    }
                    //Build user_mentions
                    if(post.user_mentions){
                        post.user_mentions.forEach((user_mention) => {
                            let user_name = '@'+user_mention.text;
                            user_mentions[post.network] = user_mentions[post.network] ?? {};
                            user_mentions[post.network][user_name] = user_mentions[post.network][user_name] ?? {};
                            user_mentions[post.network][user_name] = {
                                'url' : user_mention.url,
                                'total' : user_mentions[post.network][user_name]['total'] ? user_mentions[post.network][user_name]['total'] + 1 : 1
                            }
                        });
                    };
                });
                // Build network percents
                Object.keys(networks_counts).forEach((network) => {
                    Object.keys(networks_counts[network]).forEach((sentiment) => {
                        networks_counts[network]['percents'][sentiment] = networks_counts[network]['percents'][sentiment] || 0;
                        networks_counts[network]['percents'][sentiment] = (networks_counts[network][sentiment] / networks_counts[network]['total']) * 100;
                    });
                });

                this.posts = posts;
                this.total_posts = posts.length;
                this.sentiment_posts = sentiment_posts;
                this.networks_counts = networks_counts;
                this.frequent_words = this.sortObject(frequent_words, 3);
                this.popularity_counts = popularity_counts;
                this.tags = tags;
                Object.entries(user_mentions).forEach(entry => {
                    let [network, user_mention] = entry;
                    user_mentions[network] = this.sortObject(user_mentions[network], 50, 'total');
                });
                this.user_mentions = user_mentions;
                
                this.empty_results = this.total_posts <= 0;

                this.loading = false;
                this.filtering = false;
                this.$root.$emit('loadData');
            }).catch((error) => {
                this.$root.$emit('loadData');
            });
        },
        share(url){
           navigator.share({
                url: url,
            });
        },
        copyToClipboard(url){
            navigator.clipboard.writeText(url);
            Swal.fire({
                icon: 'success',
                title: window.translate('messages.url_to_clipboard'),
                showConfirmButton: false,
                timer: 1600
            });
        },
        renderSentimentChart(){
            this.sentimentDataCollection = {
                chart_data :{
                    labels: [
                        window.translate('messages.positive'),
                        window.translate('messages.negative'),
                    ],
                    datasets: [{
                        label: 'Sentiment',
                        borderColor: this.$root.app_config.dark_mode ? '#343a40' : 'rgba(255, 255, 255, 1)',
                        data: [
                            this.sentiment_posts.positive.length,
                            this.sentiment_posts.negative.length,
                        ],
                        backgroundColor: [
                            this.$root.app_config.dark_mode ? 'rgba(0, 188, 140, 0.7)' : 'rgba(40, 167, 69, 0.7)',
                            this.$root.app_config.dark_mode ? 'rgba(231, 76, 60, 0.7)' : 'rgba(220, 53, 69, 0.7)',
                        ]
                    }]
                },
                chart_options: {
                    legend: {
                        labels: {
                            fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                        }
                    },
                    scale: {
                        gridLines: {
                            color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                        }
                    }
                }
            };
            this.$forceUpdate();
        },
        renderNetworkChart(){
            
            var labels = [];
            var backgrounds = [];
            var data = [];
            Object.keys(this.networks_counts).forEach((network) => {
                labels.push(this.$options.filters.capitalize(network));
                backgrounds.push(this.$options.filters.network_color(network, 0.8));
                data.push(this.networks_counts[network].total);
            });
            this.networkDataCollection = {
                chart_data: {
                    labels: labels,
                    datasets: [{
                        label: 'Networks',
                        borderColor: this.$root.app_config.dark_mode ? '#343a40' : 'rgba(255, 255, 255, 1)',
                        data: data,
                        backgroundColor: backgrounds
                    }]
                },
                chart_options: {
                    legend: {
                        labels: {
                            fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                        }
                    },
                    scale: {
                        gridLines: {
                            color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                        }
                    }
                }
            }
        },
        renderSentimentOverviewChart(group_by = 'day'){
            var grouped_posts = {};
            var time_format = 'YYYY-MM-DD';
            switch(group_by){
                case 'year':
                    time_format = 'YYYY';
                    break;
                case 'month':
                    time_format = 'YYYY-MM';
                    break;
                case 'day':
                default:
                    time_format = 'YYYY-MM-DD';
                    break;
            }
            this.posts.forEach((post) => {
                let date = moment.utc(post.posted, 'YYYY-MM-DD HH:mm:ss +00000');
                let date_key = date.tz(this.$root.app_config.timezone).format(time_format);
                grouped_posts[post.sentiment] = grouped_posts[post.sentiment] || [];
                grouped_posts[post.sentiment][date_key] = grouped_posts[post.sentiment][date_key] || 0;
                grouped_posts[post.sentiment][date_key]++;
            });

            var datasets = [];
            Object.keys(grouped_posts).forEach((sentiment) => {
                var data = [];
                Object.keys(grouped_posts[sentiment]).forEach((date) => {
                    data.push({x: date, y: grouped_posts[sentiment][date]})
                });

                datasets.push({
                    label: this.translate('messages.'+sentiment),
                    data: data,
                    borderColor: this.$options.filters.sentiment_color(sentiment, 1),
                    backgroundColor: this.$options.filters.sentiment_color(sentiment, 0.4),
                    fill: true,
                    tension: 0
                });
            });

            this.sentimentOverviewDataCollection = {
                group_by : group_by,
                chart_data: {
                    datasets: datasets
                },
                chart_options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales:     {
                        xAxes: [{
                            type:       "time",
                            time:       {
                                unit: group_by,
                                format: time_format,
                                tooltipFormat: 'll'
                            },
                            scaleLabel: {
                                display:     true,
                                labelString: translate('messages.date'),
                            },
                            gridLines: {
                                color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                            },
                            ticks:{
                                fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                            }
                        }],
                        yAxes: [{
                            scaleLabel: {
                                display:     true,
                                labelString: translate('messages.mentions'),
                            },
                            gridLines: {
                                color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                            },
                            ticks: {
                                fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                            }
                        }]
                    },
                    legend: {
                        labels: {
                            fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                        }
                    },
                    elements: {
                        line: {
                            tension: 0.3
                        }
                    },
                    plugins: {
                        filler: {
                            propagate: true
                        }
                    }
                },
            }
        },
        renderNetworkOverviewChart(group_by = 'day'){
            var grouped_posts = {};
            var time_format = 'YYYY-MM-DD';
            switch(group_by){
                case 'year':
                    time_format = 'YYYY';
                    break;
                case 'month':
                    time_format = 'YYYY-MM';
                    break;
                case 'day':
                default:
                    time_format = 'YYYY-MM-DD';
                    break;
            }
            this.posts.forEach((post) => {
                let date = moment.utc(post.posted, 'YYYY-MM-DD HH:mm:ss +00000');
                let date_key = date.tz(this.$root.app_config.timezone).format(time_format);
                grouped_posts[post.network] = grouped_posts[post.network] || [];
                grouped_posts[post.network][date_key] = grouped_posts[post.network][date_key] || 0;
                grouped_posts[post.network][date_key]++;
            });

            var datasets = [];
            Object.keys(grouped_posts).forEach((network) => {
                var data = [];
                Object.keys(grouped_posts[network]).forEach((date) => {
                    data.push({x: date, y: grouped_posts[network][date]})
                });

                datasets.push({
                    label: this.$options.filters.capitalize(network),
                    data: data,
                    borderColor: this.$options.filters.network_color(network, 1),
                    backgroundColor: this.$options.filters.network_color(network, 0.4),
                    fill: true,
                    tension: 0
                });
            });

            this.networkOverviewDataCollection = {
                group_by : group_by,
                chart_data: {
                    datasets: datasets
                },
                chart_options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales:     {
                        xAxes: [{
                            type:       "time",
                            time:       {
                                unit: group_by,
                                format: time_format,
                                tooltipFormat: 'll'
                            },
                            scaleLabel: {
                                display:     true,
                                labelString: translate('messages.date')
                            },
                            gridLines: {
                                color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                            },
                            ticks:{
                                fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                            }
                        }],
                        yAxes: [{
                            beginAtZero: true,
                            scaleLabel: {
                                display:     true,
                                labelString: translate('messages.mentions')
                            },
                            gridLines: {
                                color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.2)',
                            },
                            ticks:{
                                beginAtZero: true,
                                callback: function(value) {if (value % 1 === 0) {return value;}},
                                fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                            }
                        }]
                    },
                    legend: {
                        labels: {
                            fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                        }
                    },
                    elements: {
                        line: {
                            tension: 0.3
                        }
                    },
                    plugins: {
                        filler: {
                            propagate: true
                        }
                    }
                },
            }
        },
        sortObject(unordered, max = -1, key=null) {
            if(max < 0) max = Object.keys(unordered).length;
            var sortable = [];
            for (var entry in unordered) {
                sortable.push([entry, unordered[entry]]);
            }

            if(!key){
                sortable.sort(function(a, b) {
                    return b[1] - a[1];
                });
            }else{
                sortable.sort(function(a, b) {
                    return b[1][key] - a[1][key];
                });
            }

            var objSorted = {}
            sortable.splice(0, max).forEach(function(item){
                objSorted[item[0]]=item[1]
            })

            return objSorted;
        },
        setMainFeedCardBodyHeight(){
            if(!this.main_feed_id) return;
            var timeout = null;
            if(timeout != null) {
                clearTimeout(timeout);
            }
            let v = this;
            timeout = setTimeout(function(){
                let card_body_height = $('#social-searcher-'+v.social_searcher.id).find('>.card-body').innerHeight()+'px';
                v.$root.$emit('updateFeedCardHeight', v.main_feed_id, card_body_height);
            },1000);
        },
        setNetworksFilter(network){
            if(network == 'all'){
                this.selected_networks = this.active_networks;
            }else if(network == 'none'){
                this.selected_networks = [];
            }else if(this.selected_networks.includes(network)){
                this.selected_networks=_.without(this.selected_networks,network)
            }else{
                this.selected_networks.push(network)
            }
        },
        applyFilter(){
            this.filter_applied = true;
            this.filtering = true;
            this.loadResults();
        },
        resetFilters(){
            this.filter_applied = false;
            this.date_range = [null, null];
            this.selected_networks = this.active_networks;
            this.filtering = true;
            this.loadResults();
        },
        disabledDates(date) {
            return date < this.start_date || date > this.end_date
        },
        selectLastDays(emit, days) {
            const start = new Date();
            const end = new Date();
            start.setTime(end.getTime() - (days * 24 * 3600 * 1000));
            const date = [start, end];
            emit(date);
            this.datepicker_open = false;
        },
        async generatePDF(type){
            if(this.generating_pdf) return;
            this.$Progress.start();
            this.generating_pdf = true;
            var canvas = null;
            var styles = this.overviewChartsStyles;
            this.overviewChartsStyles = {height: '300px', width: '800px'};
            switch(type){
                case 'social_networks':
                    this.renderNetworkOverviewChart(this.networkOverviewDataCollection.group_by);
                    await new Promise(resolve => setTimeout(resolve, 500));
                    canvas = this.$refs.social_networks_overview_chart.$refs.canvas;
                    var datasets = this.networkOverviewDataCollection.chart_data.datasets;
                    break;
                case 'sentiments':
                    default:
                    this.renderSentimentOverviewChart(this.sentimentOverviewDataCollection.group_by);
                    await new Promise(resolve => setTimeout(resolve, 500));
                    canvas = this.$refs.sentiment_overview_chart.$refs.canvas;
                    var datasets = this.sentimentOverviewDataCollection.chart_data.datasets;
            }

            var imageData = canvas ? canvas.toDataURL(this.$root.app_config.dark_mode ? 'image/jpeg' : 'image/png') : null;
            this.overviewChartsStyles = styles;
            this.renderSentimentOverviewChart(this.sentimentOverviewDataCollection.group_by);
            this.renderNetworkOverviewChart(this.networkOverviewDataCollection.group_by);

            var docDefinition = {
                content: [
                    {
                        columns: [
                            {image: 'user_photo', width: 80},
                            {
                                stack: [
                                    {text: 'World Eye Monitor', alignment: 'left', fontSize: 20, bold: true},
                                    {text: this.translate('messages.social_searcher')+': '+this.social_searcher.keyword, alignment: 'left', fontSize: 16, decoration: 'underline', margin: [0,5,0,0]},
                                ],
                                width : '*'
                            },
                            {text: moment().format('dddd DD MMMM YYYY HH:mm'), alignment: 'right', width: 'auto', noWrap: true},
                        ],
                        columnGap: 12,
                        margin: [-30,-30,-30,15]
                    },
                    {text: this.translate('messages.'+type)+' '+this.translate('messages.by')+' '+this.translate('messages.date'), alignment: 'left', fontSize: 16, bold: true},
                ],
                images: {
                    logo: window.location.origin+'/images/logo.png',
                    user_photo: window.location.origin+user.photo
                }
            };
            var date_range = '';
            if(this.filter_applied && this.date_range[0] && this.date_range[1]){
                date_range = this.$options.filters.localDateNoHour(this.date_range[0])+' ~ '+this.$options.filters.localDateNoHour(this.date_range[1]);
            }else{
                date_range = this.$options.filters.localDateNoHour(this.start_date)+' ~ '+this.$options.filters.localDateNoHour(this.end_date);
            }
            docDefinition.content.push({text: date_range, margin: [0,3]});

            var imageData = canvas.toDataURL(this.$root.app_config.dark_mode ? 'image/jpeg' : 'image/png');
            docDefinition.content.push({image: imageData, margin: [0,3], width: 500, alignment: 'center'});

            var columns = [this.translate('messages.date')];
            var column_widths = ['auto'];
            var data = {};
            datasets.forEach(function(dataset){
                columns.push(dataset.label);
                column_widths.push('*');
                dataset.data.forEach(function(point){
                    data[point.x] = data[point.x] ?? {};
                    data[point.x][dataset.label] = point.y;
                });
            });
            var table = {
                layout: 'lightHorizontalLines', // optional,
                table: {
                    headerRows: 1,
                    widths: column_widths,
                    body: [
                        columns
                    ]
                }
            };
            var rows = [];
            Object.keys(data).forEach(function(point){
                var row = [point]
                columns.forEach(function(column, index){
                    if(index == 0) return;
                    row = row.concat(data[point][column] ?? 0);
                });
                rows.push(row);
            });
            table.table.body = table.table.body.concat(rows.sort(function(a, b){return a[0] === b[0] ? 0 : (a[0] < b[0]) ? -1 : 1}));
            docDefinition.content.push(table);
            var v = this;
            pdfMake.createPdf(docDefinition).download(this.social_searcher.keyword.substring(0, 25).replace(/\s/g, '_')+'_'+type+'_overview_'+this.end_date.format('DDMMYYY')+'.pdf', function(){
                v.$Progress.finish();
                v.generating_pdf = false;
            });
        }
    },
    mounted() {
        this.$root.$on('renderSocialSearchersCharts', () => {
            this.renderSentimentChart();
            this.renderNetworkChart();
            this.renderSentimentOverviewChart('day');
            this.renderNetworkOverviewChart('day');
        });
        this.$root.$on('loadData', () => {
            this.loadData();
        });
        $(window).on('resize', this.setMainFeedCardBodyHeight).trigger('resize');
    },
    created() {
        this.loadResults();
    },
    beforeDestroy() {
        $(window).off('resize');
    },
    computed: {
        webShareApiSupported() {
            return navigator.share
        }
    },
    watch: {
        posts(){
            this.renderSentimentChart();
            this.renderNetworkChart();
            this.renderSentimentOverviewChart('day');
            this.renderNetworkOverviewChart('day');
            $(window).trigger('resize');
        },
        loading(){
            $(window).trigger('resize');
        }
    }
}
</script>